import type React from "react";

export default function ClockIcon() {
    return (
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity="0.35" cx="28" cy="28" r="28" fill="#26BCD7"/>
            <path d="M27.7507 25.9627V30.6556" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M27.7507 41.6064C33.7986 41.6064 38.7015 36.7036 38.7015 30.6557C38.7015 24.6078 33.7986 19.705 27.7507 19.705C21.7028 19.705 16.8 24.6078 16.8 30.6557C16.8 36.7036 21.7028 41.6064 27.7507 41.6064Z" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M37.1366 18.142L34.0086 21.2699" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.365 18.142L21.4949 21.2699" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M24.6227 13.4491H30.8805" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M27.7507 19.7069V13.4491" stroke="#24304F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

    )
}